declare var grecaptcha: any;

const FormSubmit = (target) => {

  //* Contact form and sponsors form

  const method = {
    init: () => {
      if (target) {
        const form = target;
        method.validateRecaptcha(form);

        form.addEventListener("submit", (e) => {
          e.preventDefault();
          method.submit(form);
        });
      }
    },

    validateRecaptcha: (form) => {
      const button = <HTMLButtonElement>form.querySelector("button[type=submit]");
      var recaptchaElement = <HTMLInputElement>(document.getElementsByName("g-recaptcha-response")[0]);

      if (recaptchaElement != null) {
        
        grecaptcha.ready(() => {
          // do request for recaptcha token
          // response is promise with passed token

          grecaptcha.execute(button.getAttribute('data-siteKey'), { action: 'validate_captcha' })
          .then(function (token) {
            // add token value to form
            recaptchaElement.value = token;
          });

        });
        
      }
    },

    submit: async (form) => {

      const button = form.querySelector("button[type=submit]");
      const callout = form.querySelectorAll(".callout");
      const data = new FormData(form);
      const action = form.getAttribute("action");
      const formMethod = form.getAttribute("method");

      if (callout) {
        callout.forEach(el => el.remove());
      }

      button.disabled = true;
      button.classList.add("button--loading");

      fetch(action, {
        method: formMethod,
        body: data,
      })
        .then(res => res.json())
        .then((response) => {
          if (response.success) {
            method.renderMessage(form, response.message, "success");
            form.reset();
          } else {
            method.renderMessage(form, response.message, "error");
          }
          setTimeout(() => {
            button.classList.remove("button--loading");
            button.disabled = false;
          }, 150);
        })
        .catch((ex) => {
          method.renderMessage(form, `Server error: ${ex}`, "error");
        });
    },

    renderMessage: (el, message, type) => {
      el.insertAdjacentHTML(
        "beforeend",
        `<div class="callout callout--${type}">${message}</div>`
      );
    },

  };

  method.init();
};

export default FormSubmit;
